webpackJsonp([2],{

/***/ 0:
/*!*************************!*\
  !*** multi EventRender ***!
  \*************************/
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(/*! ./src/event_render */263);


/***/ }),

/***/ 72:
/*!******************************************!*\
  !*** ./src/components/event_category.js ***!
  \******************************************/
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(/*! react */ 2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventCategory = _react2.default.createClass({
	  displayName: "EventCategory",
	
	  propTypes: {
	    onChange: _react2.default.PropTypes.func.isRequired,
	    label: _react2.default.PropTypes.string.isRequired,
	    name: _react2.default.PropTypes.string.isRequired,
	    member_validation_required: _react2.default.PropTypes.bool,
	    admin: _react2.default.PropTypes.bool
	  },
	  render: function render() {
	    var _props = this.props,
	        onChange = _props.onChange,
	        label = _props.label,
	        name = _props.name,
	        selected = _props.selected;
	
	    return _react2.default.createElement(
	      "div",
	      { className: "form-group" },
	      _react2.default.createElement(
	        "div",
	        { className: "col-lg-2 text-right" },
	        _react2.default.createElement("input", { type: "radio", name: "category", value: name, id: 'category-' + name, onChange: onChange.bind(null, { 'category': name }), checked: selected })
	      ),
	      _react2.default.createElement(
	        "label",
	        { className: "col-lg-10", htmlFor: 'category-' + name },
	        label
	      )
	    );
	  }
	});
	
	exports.default = EventCategory;

/***/ }),

/***/ 73:
/*!****************************************************!*\
  !*** ./src/components/event_category_container.js ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(/*! react */ 2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _event_category = __webpack_require__(/*! ./event_category */ 72);
	
	var _event_category2 = _interopRequireDefault(_event_category);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventCategoryContainer = _react2.default.createClass({
	  displayName: 'EventCategoryContainer',
	
	  propTypes: {
	    categories: _react2.default.PropTypes.array
	  },
	  render: function render() {
	    var _props = this.props,
	        onChange = _props.onChange,
	        categories = _props.categories;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'panel' },
	      _react2.default.createElement(
	        'div',
	        { className: 'panel-heading' },
	        _react2.default.createElement(
	          'div',
	          { className: 'panel-title' },
	          ' ',
	          _react2.default.createElement('span', { className: 'glyphicon glyphicon-user' }),
	          ' Please select a registration category '
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'panel-body' },
	        categories.map(function (c) {
	          return _react2.default.createElement(_event_category2.default, _extends({ key: c.id, onChange: onChange }, c));
	        })
	      )
	    );
	  }
	});
	
	exports.default = EventCategoryContainer;

/***/ }),

/***/ 74:
/*!***********************************************!*\
  !*** ./src/components/event_fee_container.js ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(/*! react */ 2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventFeeContainer = _react2.default.createClass({
	  displayName: 'EventFeeContainer',
	
	  propTypes: {
	    fees: _react2.default.PropTypes.array,
	    onIncreaseFeeQty: _react2.default.PropTypes.func.isRequired,
	    onDecreaseFeeQty: _react2.default.PropTypes.func.isRequired
	  },
	  increaseFeeQty: function increaseFeeQty(name, price, limit, total_limit, qty, id, label, is_front_end) {
	    var _this = this;
	
	    var data = { fee_id: id, fee_name: name, front_end: is_front_end };
	
	    $.ajax({
	      url: '/events/get_limit_total',
	      type: 'POST',
	      data: data,
	      dataType: 'json'
	    }).done(function (data, textStatus, jqXHR) {
	
	      //skip validation in backend
	      if (is_front_end === true) {
	        //reutrn current DB count
	        var currentCount = data.currentCount;
	
	        if (total_limit > 0 && qty + 1 + currentCount > total_limit) {
	          return swal({
	            title: 'Error',
	            text: 'Sorry, "' + label + '" has reached the maximum capacity.',
	            type: 'error'
	          });
	        }
	
	        if (++qty > limit) {
	          return swal({
	            title: 'Error',
	            text: limit == 1 ? 'You may only register for this item once' : 'You may only register for this item a maximum of ' + limit + ' times.',
	            type: 'error'
	          });
	        }
	      }
	
	      _this.props.onIncreaseFeeQty(name, price);
	    }).fail(function (jqXHR, textStatus) {
	      var response = $.parseJSON(jqXHR.responseText);
	      return swal({
	        title: 'Error',
	        text: response.error.message,
	        type: 'error'
	      });
	    });
	  },
	
	  render: function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        is_front_end = _props.is_front_end,
	        admin = _props.admin,
	        onIncreaseFeeQty = _props.onIncreaseFeeQty,
	        onDecreaseFeeQty = _props.onDecreaseFeeQty,
	        onChange = _props.onChange,
	        fees = _props.fees;
	
	    // console.log(this.props);
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'panel' },
	      _react2.default.createElement(
	        'div',
	        { className: 'panel-heading' },
	        _react2.default.createElement(
	          'div',
	          { className: 'panel-title' },
	          ' ',
	          _react2.default.createElement('span', { className: 'glyphicon glyphicon-list-alt' }),
	          ' Please select items '
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'panel-body' },
	        _react2.default.createElement(
	          'table',
	          { className: 'table table-striped' },
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                { className: 'col-sm-7' },
	                'Register Me For:'
	              ),
	              _react2.default.createElement(
	                'th',
	                { className: 'col-sm-2' },
	                'Price'
	              ),
	              _react2.default.createElement(
	                'th',
	                { className: 'col-sm-3' },
	                'Qty'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            !fees ? undefined : fees.map(function (f) {
	              return _react2.default.createElement(
	                'tr',
	                { key: f.id },
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  f.label
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  '$',
	                  f.price
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  f.is_sold_out && f.is_sold_out == true && is_front_end == true ? _react2.default.createElement(
	                    'div',
	                    { className: 'sold-out-contaner' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'text-danger text-center font-weight-bold' },
	                      'SOLD OUT!'
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'input-group' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'input-group-btn' },
	                      _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-default', type: 'button', onClick: onDecreaseFeeQty.bind(null, f.name, f.price) },
	                        '-'
	                      )
	                    ),
	                    _react2.default.createElement('input', { type: 'number', className: 'form-control text-center', name: f.name, value: f.qty, readOnly: true }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'input-group-btn' },
	                      _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-default', type: 'button', onClick: _this2.increaseFeeQty.bind(null, f.name, f.price, f.limit, f.total_limit, f.qty, f.id, f.label, is_front_end) },
	                        '+'
	                      )
	                    )
	                  )
	                )
	              );
	            })
	          )
	        )
	      )
	    );
	  }
	});
	
	exports.default = EventFeeContainer;

/***/ }),

/***/ 75:
/*!**************************************************************!*\
  !*** ./src/components/event_form_accommodation_container.js ***!
  \**************************************************************/
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(/*! react */ 2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(/*! jquery */ 11);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var EventFormAccommodationContainer = _react2.default.createClass({
	  displayName: 'EventFormAccommodationContainer',
	
	  // propTypes: {
	  //   fields: React.PropTypes.array
	  // },
	  componentDidUpdate: function componentDidUpdate() {
	    var _this = this;
	
	    (0, _jquery2.default)(this.refs.root).find('.input-daterange').datepicker({
	      format: 'yyyy-mm-dd',
	      todayBtn: 'linked',
	      autoclose: true,
	      clearBtn: true
	    }).on('changeDate', function (e) {
	      return _this.props.onChange(_defineProperty({}, e.target.name, e.target.value));
	    });
	  },
	  componentDidMount: function componentDidMount() {
	    this.componentDidUpdate();
	  },
	  render: function render() {
	    var _props = this.props,
	        _onChange = _props.onChange,
	        accommodation = _props.accommodation;
	
	    return _react2.default.createElement(
	      'div',
	      { ref: 'root', className: 'panel' },
	      _react2.default.createElement(
	        'div',
	        { className: 'panel-heading' },
	        _react2.default.createElement(
	          'div',
	          { className: 'panel-title' },
	          ' ',
	          _react2.default.createElement('span', { className: 'glyphicons glyphicons-building' }),
	          ' Hotel Information '
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'panel-body' },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group' },
	          _react2.default.createElement(
	            'label',
	            { className: 'col-lg-2 control-label' },
	            'Do you require hotel reservations?'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-10' },
	            _react2.default.createElement(
	              'label',
	              { className: 'radio' },
	              _react2.default.createElement('input', { className: 'radio', type: 'radio', name: 'required', value: true, checked: accommodation.required, onChange: function onChange(e) {
	                  return _onChange({ required: true });
	                } }),
	              'YES'
	            ),
	            _react2.default.createElement(
	              'label',
	              { className: 'radio' },
	              _react2.default.createElement('input', { className: 'radio', type: 'radio', name: 'required', value: false, checked: !accommodation.required, onChange: function onChange(e) {
	                  return _onChange({ required: false });
	                } }),
	              'NO'
	            )
	          )
	        ),
	        !accommodation.required ? undefined : _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-lg-2 control-label' },
	              'Occupancy'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-10' },
	              _react2.default.createElement(
	                'label',
	                { className: 'radio' },
	                _react2.default.createElement('input', { className: 'radio', type: 'radio', name: 'occupancy', value: 'single', checked: accommodation.occupancy == 'single', onChange: function onChange(e) {
	                    return _onChange({ occupancy: 'single' });
	                  } }),
	                'Single'
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'radio' },
	                _react2.default.createElement('input', { className: 'radio', type: 'radio', name: 'occupancy', value: 'double', checked: accommodation.occupancy == 'double', onChange: function onChange(e) {
	                    return _onChange({ occupancy: 'double' });
	                  } }),
	                'Double'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-lg-2 control-label' },
	              'Date of check in / check out'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-10' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-daterange' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'input-group-addon' },
	                  _react2.default.createElement('i', { className: 'glyphicons glyphicons-calendar' })
	                ),
	                _react2.default.createElement('input', { type: 'text', name: 'checkin_date', className: 'form-control margin-top-none', value: accommodation.checkin_date }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'input-group-addon' },
	                  'to'
	                ),
	                _react2.default.createElement('input', { type: 'text', name: 'checkout_date', className: 'form-control margin-top-none', value: accommodation.checkout_date })
	              )
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	exports.default = EventFormAccommodationContainer;

/***/ }),

/***/ 76:
/*!********************************************!*\
  !*** ./src/components/event_form_field.js ***!
  \********************************************/
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(/*! react */ 2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _event_form_field_text = __webpack_require__(/*! ./event_form_field_text */ 82);
	
	var _event_form_field_text2 = _interopRequireDefault(_event_form_field_text);
	
	var _event_form_field_email = __webpack_require__(/*! ./event_form_field_email */ 80);
	
	var _event_form_field_email2 = _interopRequireDefault(_event_form_field_email);
	
	var _event_form_field_dropdown = __webpack_require__(/*! ./event_form_field_dropdown */ 79);
	
	var _event_form_field_dropdown2 = _interopRequireDefault(_event_form_field_dropdown);
	
	var _event_form_field_display = __webpack_require__(/*! ./event_form_field_display */ 78);
	
	var _event_form_field_display2 = _interopRequireDefault(_event_form_field_display);
	
	var _event_form_field_radio = __webpack_require__(/*! ./event_form_field_radio */ 81);
	
	var _event_form_field_radio2 = _interopRequireDefault(_event_form_field_radio);
	
	var _event_form_field_checkbox = __webpack_require__(/*! ./event_form_field_checkbox */ 77);
	
	var _event_form_field_checkbox2 = _interopRequireDefault(_event_form_field_checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventFormField = _react2.default.createClass({
	  displayName: 'EventFormField',
	
	  propTypes: {
	    onChange: _react2.default.PropTypes.func.isRequired,
	    label: _react2.default.PropTypes.string.isRequired,
	    name: _react2.default.PropTypes.string.isRequired,
	    value: _react2.default.PropTypes.any.isRequired,
	    field_type: _react2.default.PropTypes.string.isRequired,
	    response_options: _react2.default.PropTypes.array,
	    required: _react2.default.PropTypes.bool,
	    locked: _react2.default.PropTypes.bool
	  },
	  render: function render() {
	    var _props = this.props,
	        label = _props.label,
	        name = _props.name,
	        field_type = _props.field_type,
	        required = _props.required;
	
	    var components = {
	      'text': _event_form_field_text2.default,
	      'email': _event_form_field_email2.default,
	      'dropdown': _event_form_field_dropdown2.default,
	      'display': _event_form_field_display2.default,
	      'radio': _event_form_field_radio2.default,
	      'checkbox': _event_form_field_checkbox2.default
	    };
	    var Component = components[field_type];
	    return _react2.default.createElement(Component, this.props);
	  }
	});
	
	exports.default = EventFormField;

/***/ }),

/***/ 77:
/*!*****************************************************!*\
  !*** ./src/components/event_form_field_checkbox.js ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(/*! react */ 2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventFormFieldCheckbox = _react2.default.createClass({
	  displayName: "EventFormFieldCheckbox",
	
	  render: function render() {
	
	    var checkedLink = {
	      value: this.props.checked,
	      requestChange: function (newValue) {
	        this.props.onChange.call(null, { target: { name: this.props.name, value: newValue } });
	      }.bind(this)
	    };
	
	    var _props = this.props,
	        onChange = _props.onChange,
	        label = _props.label,
	        name = _props.name,
	        value = _props.value,
	        response_options = _props.response_options,
	        required = _props.required;
	    // console.log(this.props);
	
	    var checkbox_options = response_options.map(function (o, i) {
	
	      if (value.indexOf(o.name) > -1) {
	        return [_react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "label",
	            null,
	            _react2.default.createElement("input", { type: "checkbox", key: o.id, name: name, value: o.name, checkedLink: checkedLink, defaultChecked: true }),
	            "\xA0",
	            o.label,
	            " "
	          )
	        )];
	      } else {
	        return [_react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "label",
	            null,
	            _react2.default.createElement("input", { type: "checkbox", key: o.id, name: name, value: o.name, checkedLink: checkedLink }),
	            "\xA0",
	            o.label,
	            " "
	          )
	        )];
	      }
	    });
	
	    return _react2.default.createElement(
	      "div",
	      { className: "form-group" },
	      _react2.default.createElement(
	        "label",
	        { className: "col-lg-2 control-label" },
	        label,
	        required ? '*' : undefined
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-lg-10" },
	        checkbox_options
	      )
	    );
	  }
	});
	
	exports.default = EventFormFieldCheckbox;

/***/ }),

/***/ 78:
/*!****************************************************!*\
  !*** ./src/components/event_form_field_display.js ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(/*! react */ 2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventFormFieldDisplay = _react2.default.createClass({
	  displayName: "EventFormFieldDisplay",
	
	  propTypes: {
	    label: _react2.default.PropTypes.string,
	    display_text: _react2.default.PropTypes.string,
	    name: _react2.default.PropTypes.string
	  },
	  render: function render() {
	    var _props = this.props,
	        label = _props.label,
	        display_text = _props.display_text,
	        name = _props.name;
	
	    return _react2.default.createElement(
	      "div",
	      { className: "form-group" },
	      _react2.default.createElement(
	        "label",
	        { className: "col-lg-12" },
	        label
	      ),
	      _react2.default.createElement(
	        "p",
	        { className: "col-lg-12" },
	        display_text
	      )
	    );
	  }
	});
	
	exports.default = EventFormFieldDisplay;

/***/ }),

/***/ 79:
/*!*****************************************************!*\
  !*** ./src/components/event_form_field_dropdown.js ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(/*! react */ 2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var EventFormFieldDropdown = _react2.default.createClass({
	  displayName: "EventFormFieldDropdown",
	
	  render: function render() {
	    var _props = this.props,
	        _onChange2 = _props.onChange,
	        label = _props.label,
	        name = _props.name,
	        value = _props.value,
	        response_options = _props.response_options,
	        required = _props.required;
	
	    var option_nodes = [_react2.default.createElement("option", null)].concat(response_options.map(function (o, i) {
	      return _react2.default.createElement(
	        "option",
	        { key: o.id, value: o.name },
	        o.label
	      );
	    }));
	    return _react2.default.createElement(
	      "div",
	      { className: "form-group" },
	      _react2.default.createElement(
	        "label",
	        { className: "col-lg-2 control-label" },
	        label,
	        required ? '*' : undefined
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-lg-10" },
	        _react2.default.createElement(
	          "select",
	          { className: "form-control", name: name, value: value, onChange: function onChange(e) {
	              return _onChange2(_defineProperty({}, name, e.target.value));
	            } },
	          option_nodes
	        )
	      )
	    );
	  }
	});
	
	exports.default = EventFormFieldDropdown;

/***/ }),

/***/ 80:
/*!**************************************************!*\
  !*** ./src/components/event_form_field_email.js ***!
  \**************************************************/
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(/*! react */ 2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var EventFormFieldEmail = _react2.default.createClass({
	  displayName: 'EventFormFieldEmail',
	
	  validateEmail: function validateEmail() {
	    var _this = this;
	
	    var data = { email: this.refs.email.value };
	    $.ajax({
	      url: '/events/email_lookup',
	      type: 'POST',
	      data: data,
	      dataType: 'json'
	    }).done(function (data, textStatus, jqXHR) {
	      swal('Success', 'Thank you, your membership has been validated.', 'success');
	      _this.props.onValidateEmail(data.member);
	    }).fail(function (jqXHR, textStatus) {
	      var response = $.parseJSON(jqXHR.responseText);
	      return swal({
	        title: 'Error',
	        text: response.error.message,
	        type: 'error'
	      });
	    });
	  },
	  render: function render() {
	    var _props = this.props,
	        _onChange2 = _props.onChange,
	        label = _props.label,
	        name = _props.name,
	        value = _props.value,
	        required = _props.required,
	        validatedMembership = _props.validatedMembership;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'form-group' },
	        _react2.default.createElement(
	          'label',
	          { className: 'col-lg-2 control-label' },
	          label,
	          required ? '*' : undefined
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-lg-8' },
	          _react2.default.createElement('input', { type: 'email', className: 'form-control', name: name, value: value, onChange: function onChange(e) {
	              return _onChange2(_defineProperty({}, name, e.target.value));
	            }, ref: 'email' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-lg-2 hide-admin' },
	          validatedMembership ? _react2.default.createElement(
	            'button',
	            { type: 'button', className: 'btn btn-info btn-gradient', disabled: 'disabled' },
	            'Validated!'
	          ) : _react2.default.createElement(
	            'button',
	            { type: 'button', className: 'btn btn-info btn-gradient', onClick: this.validateEmail },
	            'Validate'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'form-group hide-admin' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-lg-offset-2 col-lg-10' },
	          _react2.default.createElement(
	            'span',
	            { className: 'help-block margin-top-sm' },
	            _react2.default.createElement('i', { className: 'glyphicons glyphicons-circle_info' }),
	            ' OPTIONAL: Please enter your e-mail address to auto-fill the form.'
	          )
	        )
	      )
	    );
	  }
	});
	
	exports.default = EventFormFieldEmail;

/***/ }),

/***/ 81:
/*!**************************************************!*\
  !*** ./src/components/event_form_field_radio.js ***!
  \**************************************************/
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(/*! react */ 2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventFormFieldRadio = _react2.default.createClass({
	  displayName: "EventFormFieldRadio",
	
	  render: function render() {
	    var _props = this.props,
	        onChange = _props.onChange,
	        label = _props.label,
	        name = _props.name,
	        value = _props.value,
	        response_options = _props.response_options,
	        required = _props.required;
	
	    var radio_options = response_options.map(function (o, i) {
	
	      if (value == o.name) {
	        return [_react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "label",
	            null,
	            _react2.default.createElement("input", { type: "radio", key: o.id, name: name, value: o.name, defaultChecked: true }),
	            "\xA0",
	            o.label,
	            " "
	          )
	        )];
	      } else {
	        return [_react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "label",
	            null,
	            _react2.default.createElement("input", { type: "radio", key: o.id, name: name, value: o.name }),
	            "\xA0",
	            o.label,
	            " "
	          )
	        )];
	      }
	    });
	
	    return _react2.default.createElement(
	      "div",
	      { className: "form-group" },
	      _react2.default.createElement(
	        "label",
	        { className: "col-lg-2 control-label" },
	        label,
	        required ? '*' : undefined
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-lg-10" },
	        radio_options
	      )
	    );
	  }
	});
	
	exports.default = EventFormFieldRadio;

/***/ }),

/***/ 82:
/*!*************************************************!*\
  !*** ./src/components/event_form_field_text.js ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(/*! react */ 2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var EventFormFieldText = _react2.default.createClass({
	  displayName: "EventFormFieldText",
	
	  propTypes: {
	    form: _react2.default.PropTypes.string
	  },
	  render: function render() {
	    var _props = this.props,
	        _onChange2 = _props.onChange,
	        label = _props.label,
	        name = _props.name,
	        value = _props.value,
	        required = _props.required;
	
	    return _react2.default.createElement(
	      "div",
	      { className: "form-group" },
	      _react2.default.createElement(
	        "label",
	        { className: "col-lg-2 control-label" },
	        label,
	        required ? '*' : undefined
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-lg-10" },
	        _react2.default.createElement("input", { type: "text", className: "form-control", name: name, value: value, onChange: function onChange(e) {
	            return _onChange2(_defineProperty({}, name, e.target.value));
	          } })
	      )
	    );
	  }
	});
	
	exports.default = EventFormFieldText;

/***/ }),

/***/ 83:
/*!*******************************************************!*\
  !*** ./src/components/event_form_fields_container.js ***!
  \*******************************************************/
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(/*! react */ 2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _event_form_field = __webpack_require__(/*! ./event_form_field */ 76);
	
	var _event_form_field2 = _interopRequireDefault(_event_form_field);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventFormFieldsContainer = _react2.default.createClass({
	  displayName: 'EventFormFieldsContainer',
	
	  propTypes: {
	    fields: _react2.default.PropTypes.array
	  },
	  render: function render() {
	    var _props = this.props,
	        onChange = _props.onChange,
	        onValidateEmail = _props.onValidateEmail,
	        validatedMembership = _props.validatedMembership,
	        fields = _props.fields;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'panel' },
	      _react2.default.createElement(
	        'div',
	        { className: 'panel-heading' },
	        _react2.default.createElement(
	          'div',
	          { className: 'panel-title' },
	          ' ',
	          _react2.default.createElement('span', { className: 'glyphicon glyphicon-user' }),
	          ' Details '
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'panel-body' },
	        fields.map(function (f) {
	          return _react2.default.createElement(_event_form_field2.default, _extends({ key: f.name, onChange: onChange, onValidateEmail: onValidateEmail, validatedMembership: validatedMembership }, f));
	        })
	      )
	    );
	  }
	});
	
	exports.default = EventFormFieldsContainer;

/***/ }),

/***/ 84:
/*!********************************************************!*\
  !*** ./src/components/event_form_payment_container.js ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(/*! react */ 2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventFormPaymentContainer = _react2.default.createClass({
	  displayName: 'EventFormPaymentContainer',
	
	  onChange: function onChange() {
	    function numeric(val) {
	      return val.replace(/\D/g, '');
	    }
	
	    var change = {
	      payment_method: this.refs.payment_method_cheque.checked ? 'cheque' : this.refs.payment_method_credit.checked ? 'credit_card' : undefined,
	      name: this.refs.name ? this.refs.name.value : undefined,
	      number: this.refs.number ? numeric(this.refs.number.value) : undefined,
	      exp_month: this.refs.exp_month ? numeric(this.refs.exp_month.value) : undefined,
	      exp_year: this.refs.exp_year ? numeric(this.refs.exp_year.value) : undefined,
	      cvc: this.refs.cvc ? numeric(this.refs.cvc.value) : undefined
	    };
	
	    for (var i in change) {
	      if (change[i] === null || change[i] === undefined || change[i] === '') {
	        delete change[i];
	      }
	    }
	
	    return this.props.onChange(change);
	  },
	  render: function render() {
	    var _props = this.props,
	        admin = _props.admin,
	        onChange = _props.onChange,
	        onComplimentaryChange = _props.onComplimentaryChange,
	        complimentary = _props.complimentary,
	        payment_method = _props.payment_method,
	        name = _props.name,
	        number = _props.number,
	        exp_month = _props.exp_month,
	        exp_year = _props.exp_year,
	        cvc = _props.cvc,
	        subtotal = _props.subtotal,
	        tax_name = _props.tax_name,
	        tax = _props.tax,
	        total = _props.total,
	        readOnly = _props.readOnly,
	        allow_cheque = _props.allow_cheque;
	
	    // console.log(this.props);
	
	    var cc_details = _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'form-group' },
	        _react2.default.createElement(
	          'label',
	          { className: 'col-lg-2 control-label' },
	          'Name on Credit Card'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-lg-10' },
	          _react2.default.createElement('input', { type: 'text', className: 'form-control', ref: 'name', onChange: this.onChange, value: name })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'form-group' },
	        _react2.default.createElement(
	          'label',
	          { className: 'col-lg-2 control-label' },
	          'Credit Card Number'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-lg-10' },
	          _react2.default.createElement('input', { type: 'text', className: 'form-control', ref: 'number', onChange: this.onChange, value: number })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'form-group' },
	        _react2.default.createElement(
	          'label',
	          { className: 'col-lg-2 control-label' },
	          'Credit Card Expiry'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-lg-4' },
	          _react2.default.createElement(
	            'div',
	            { className: 'input-group col-sm-8' },
	            _react2.default.createElement('input', { type: 'text', className: 'form-control', placeholder: 'MM', maxLength: '2', ref: 'exp_month', onChange: this.onChange, value: exp_month }),
	            _react2.default.createElement(
	              'span',
	              { className: 'input-group-addon' },
	              '/'
	            ),
	            _react2.default.createElement('input', { type: 'text', className: 'form-control', placeholder: 'YYYY', maxLength: '4', ref: 'exp_year', onChange: this.onChange, value: exp_year })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'form-group' },
	        _react2.default.createElement(
	          'label',
	          { className: 'col-lg-2 control-label' },
	          'Credit Card CVC'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-lg-2' },
	          _react2.default.createElement('input', { type: 'text', className: 'form-control', ref: 'cvc', maxLength: '4', onChange: this.onChange, value: cvc })
	        )
	      )
	    );
	
	    var payment_section = _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'form-group' },
	        _react2.default.createElement(
	          'label',
	          { className: 'col-lg-2 control-label' },
	          'Payment Method'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-lg-10' },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement('input', { type: 'radio', name: 'payment_method', ref: 'payment_method_cheque', onChange: this.onChange, value: 'cheque' }),
	            ' Cheque'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement('input', { type: 'radio', name: 'payment_method', ref: 'payment_method_credit', onChange: this.onChange, value: 'credit_card' }),
	            ' Credit Card'
	          )
	        )
	      ),
	      payment_method != 'credit_card' ? undefined : cc_details
	    );
	
	    var payment_section_no_cheque = _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'form-group' },
	        _react2.default.createElement(
	          'label',
	          { className: 'col-lg-2 control-label' },
	          'Payment Method'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-lg-10' },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement('input', { type: 'radio', name: 'payment_method', ref: 'payment_method_cheque', onChange: this.onChange, value: 'cheque', disabled: true }),
	            ' Cheque (Not Available)'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement('input', { type: 'radio', name: 'payment_method', ref: 'payment_method_credit', onChange: this.onChange, value: 'credit_card' }),
	            ' Credit Card'
	          )
	        )
	      ),
	      payment_method != 'credit_card' ? undefined : cc_details
	    );
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'panel' },
	      _react2.default.createElement(
	        'div',
	        { className: 'panel-heading' },
	        _react2.default.createElement(
	          'div',
	          { className: 'panel-title' },
	          ' ',
	          _react2.default.createElement('span', { className: 'glyphicons glyphicons-credit_card' }),
	          ' Payment Details '
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'panel-body' },
	        _react2.default.createElement(
	          'div',
	          { className: 'well' },
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-lg-2 control-label' },
	              'Subtotal'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-10' },
	              '$',
	              parseFloat(subtotal).toFixed(2)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-lg-2 control-label' },
	              tax_name ? tax_name : 'Tax'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-10' },
	              '$',
	              parseFloat(tax).toFixed(2)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-lg-2 control-label' },
	              'Total'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-10' },
	              '$',
	              parseFloat(total).toFixed(2)
	            )
	          )
	        ),
	        readOnly ? undefined : allow_cheque ? payment_section : payment_section_no_cheque,
	        admin.isAdmin ? _react2.default.createElement(
	          'div',
	          { className: 'form-group' },
	          _react2.default.createElement(
	            'label',
	            { className: 'col-lg-2 control-label' },
	            'ADMIN'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-10' },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement('input', { type: 'checkbox', name: 'admin_bypass_payment', ref: 'admin_bypass_payment', checked: complimentary, onChange: function onChange(e) {
	                  return onComplimentaryChange(e.target.checked);
	                }, value: 1 }),
	              ' Mark as complimentary (bypass payment)'
	            )
	          )
	        ) : undefined
	      )
	    );
	  }
	});
	
	exports.default = EventFormPaymentContainer;

/***/ }),

/***/ 245:
/*!****************************************!*\
  !*** ./src/components/event_banner.js ***!
  \****************************************/
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(/*! react */ 2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventBanner = _react2.default.createClass({
	  displayName: "EventBanner",
	
	  propTypes: {
	    src: _react2.default.PropTypes.string
	  },
	  render: function render() {
	    var src = this.props.src;
	
	    return _react2.default.createElement(
	      "div",
	      { className: "row" },
	      _react2.default.createElement(
	        "div",
	        { className: "col-sm-offset-2 col-sm-8" },
	        !src ? undefined : _react2.default.createElement("img", { src: '/uploads/events/banners/' + src, className: "img-responsive event-logo" })
	      )
	    );
	  }
	});
	
	exports.default = EventBanner;

/***/ }),

/***/ 246:
/*!**********************************************!*\
  !*** ./src/components/event_form_summary.js ***!
  \**********************************************/
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(/*! react */ 2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventFormSummary = _react2.default.createClass({
	  displayName: "EventFormSummary",
	
	  // propTypes: {
	  //   fields: React.PropTypes.array
	  // },
	  render: function render() {
	    var _props = this.props,
	        onChange = _props.onChange,
	        fields = _props.fields;
	
	    return _react2.default.createElement(
	      "div",
	      { className: "panel" },
	      _react2.default.createElement(
	        "div",
	        { className: "panel-heading" },
	        _react2.default.createElement(
	          "div",
	          { className: "panel-title" },
	          " ",
	          _react2.default.createElement("span", { className: "glyphicons glyphicons-ok_2" }),
	          " Order Summary "
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "panel-body" },
	        _react2.default.createElement(
	          "div",
	          { className: "form-group" },
	          _react2.default.createElement(
	            "label",
	            { className: "col-lg-2 control-label" },
	            "Name on Credit Card"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-lg-10" },
	            _react2.default.createElement("input", { type: "text", className: "form-control" })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "form-group" },
	          _react2.default.createElement(
	            "label",
	            { className: "col-lg-2 control-label" },
	            "Credit Card Number"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-lg-10" },
	            _react2.default.createElement("input", { type: "text", className: "form-control" })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "form-group" },
	          _react2.default.createElement(
	            "label",
	            { className: "col-lg-2 control-label" },
	            "Credit Card Expiry"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-lg-4" },
	            _react2.default.createElement(
	              "div",
	              { className: "input-group col-sm-8" },
	              _react2.default.createElement("input", { type: "text", id: "card_exp_month", className: "form-control", placeholder: "MM", "data-stripe": "exp-month", maxLength: "2", required: true }),
	              _react2.default.createElement(
	                "span",
	                { className: "input-group-addon" },
	                "/"
	              ),
	              _react2.default.createElement("input", { type: "text", id: "card_exp_year", className: "form-control", placeholder: "YYYY", maxLength: "4", required: true })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "form-group" },
	          _react2.default.createElement(
	            "label",
	            { className: "col-lg-2 control-label" },
	            "Credit Card CVC"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-lg-2" },
	            _react2.default.createElement("input", { type: "text", className: "form-control" })
	          )
	        )
	      )
	    );
	  }
	});
	
	exports.default = EventFormSummary;

/***/ }),

/***/ 247:
/*!******************************************!*\
  !*** ./src/components/event_thankyou.js ***!
  \******************************************/
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(/*! react */ 2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventThankyou = _react2.default.createClass({
	  displayName: "EventThankyou",
	
	  propTypes: {
	    message: _react2.default.PropTypes.string,
	    continueUrl: _react2.default.PropTypes.string
	  },
	  render: function render() {
	    var _props = this.props,
	        message = _props.message,
	        continueUrl = _props.continueUrl;
	
	
	    return _react2.default.createElement(
	      "div",
	      { className: "row" },
	      _react2.default.createElement(
	        "div",
	        { className: "col-sm-offset-2 col-sm-8" },
	        _react2.default.createElement(
	          "div",
	          { className: "panel" },
	          _react2.default.createElement(
	            "div",
	            { className: "panel-heading" },
	            _react2.default.createElement(
	              "div",
	              { className: "panel-title" },
	              " ",
	              _react2.default.createElement("span", { className: "glyphicon glyphicon-ok" }),
	              " Thank you "
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "panel-body" },
	            message.split('\n').map(function (item, key) {
	              return _react2.default.createElement(
	                "span",
	                { key: key },
	                item,
	                _react2.default.createElement("br", null)
	              );
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "panel-footer text-right" },
	            _react2.default.createElement(
	              "a",
	              { href: continueUrl, className: "btn btn-info btn-gradient" },
	              "Continue"
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	exports.default = EventThankyou;

/***/ }),

/***/ 261:
/*!*******************************************!*\
  !*** ./src/event_render/actions/index.js ***!
  \*******************************************/
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateForm = updateForm;
	exports.increaseFeeQty = increaseFeeQty;
	exports.decreaseFeeQty = decreaseFeeQty;
	exports.updatePaymentDetails = updatePaymentDetails;
	exports.changeComplimentary = changeComplimentary;
	exports.updateAccommodationDetails = updateAccommodationDetails;
	exports.finalizeLogin = finalizeLogin;
	exports.finalizeSubmission = finalizeSubmission;
	function updateForm(change) {
	  return { type: 'UPDATE_FORM', change: change };
	}
	
	function increaseFeeQty(fee_name, price) {
	  return { type: 'INCREASE_FEE_QTY', fee_name: fee_name, price: price };
	}
	
	function decreaseFeeQty(fee_name) {
	  return { type: 'DECREASE_FEE_QTY', fee_name: fee_name };
	}
	
	function updatePaymentDetails(change) {
	  return { type: 'UPDATE_PAYMENT_DETAILS', change: change };
	}
	
	function changeComplimentary(complimentary) {
	  return { type: 'CHANGE_COMPLIMENTARY', complimentary: complimentary };
	}
	
	function updateAccommodationDetails(change) {
	  return { type: 'UPDATE_ACCOMMODATION_DETAILS', change: change };
	}
	
	function finalizeLogin(change) {
	  return { type: 'FINALIZE_LOGIN', change: change };
	}
	
	function finalizeSubmission() {
	  return { type: 'FINALIZE_SUBMISSION' };
	}

/***/ }),

/***/ 262:
/*!*****************************************************!*\
  !*** ./src/event_render/containers/event_render.js ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _sweetalert = __webpack_require__(/*! sweetalert */ 42);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	__webpack_require__(/*! sweetalert/dist/sweetalert.css */ 46);
	
	var _jquery = __webpack_require__(/*! jquery */ 11);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(/*! react */ 2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(/*! redux */ 15);
	
	var _reactRedux = __webpack_require__(/*! react-redux */ 21);
	
	var _actions = __webpack_require__(/*! ../actions */ 261);
	
	var FormActions = _interopRequireWildcard(_actions);
	
	var _event_banner = __webpack_require__(/*! ../../components/event_banner */ 245);
	
	var _event_banner2 = _interopRequireDefault(_event_banner);
	
	var _event_category_container = __webpack_require__(/*! ../../components/event_category_container */ 73);
	
	var _event_category_container2 = _interopRequireDefault(_event_category_container);
	
	var _event_fee_container = __webpack_require__(/*! ../../components/event_fee_container */ 74);
	
	var _event_fee_container2 = _interopRequireDefault(_event_fee_container);
	
	var _event_form_fields_container = __webpack_require__(/*! ../../components/event_form_fields_container */ 83);
	
	var _event_form_fields_container2 = _interopRequireDefault(_event_form_fields_container);
	
	var _event_form_accommodation_container = __webpack_require__(/*! ../../components/event_form_accommodation_container */ 75);
	
	var _event_form_accommodation_container2 = _interopRequireDefault(_event_form_accommodation_container);
	
	var _event_form_payment_container = __webpack_require__(/*! ../../components/event_form_payment_container */ 84);
	
	var _event_form_payment_container2 = _interopRequireDefault(_event_form_payment_container);
	
	var _event_form_summary = __webpack_require__(/*! ../../components/event_form_summary */ 246);
	
	var _event_form_summary2 = _interopRequireDefault(_event_form_summary);
	
	var _event_thankyou = __webpack_require__(/*! ../../components/event_thankyou */ 247);
	
	var _event_thankyou2 = _interopRequireDefault(_event_thankyou);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventRender = _react2.default.createClass({
	  displayName: 'EventRender',
	
	  validateForm: function validateForm(data) {
	    var errors = [];
	
	    // category
	    if (!data.form.category) {
	      errors.push('Please select a registration category.');
	    }
	
	    // console.log(this.props.fields);
	    // console.log(data.form);
	    // console.log(data.form.hasOwnProperty("radiotest"));
	
	
	    // form fields
	    var missing_fields = [];
	    // const missing_fields = this.props.fields.filter( (f) => f.required && !data.form.hasOwnProperty(f.name)).map( (f) => 'The '+f.label+' field is required.');
	    // const missing_fields = this.props.fields.filter( (f) => f.required && !data.form.hasOwnProperty(f.name) && !(f.field_type == 'checkbox' || f.field_type == 'radio')).map( (f) => 'The '+f.label+' field is required.');
	
	
	    $(this.props.fields).each(function (index) {
	      var field = $(this)[0];
	      console.log(field.name);
	
	      if (field.required) {
	        switch (field.field_type) {
	          case 'radio':
	          case 'checkbox':
	            if (!$("input[name='" + field.name + "']:checked").val()) {
	              missing_fields.push('The ' + field.label + ' field is required.');
	            }
	            break;
	          case 'text':
	          case 'email':
	            if (!$("input[name='" + field.name + "']").val()) {
	              missing_fields.push('The ' + field.label + ' field is required.');
	            }
	            break;
	          case 'dropdown':
	            if (!$("select[name='" + field.name + "']").val()) {
	              missing_fields.push('The ' + field.label + ' field is required.');
	            }
	            break;
	          default:
	          // code block
	        }
	      }
	    });
	
	    errors = errors.concat(missing_fields);
	
	    // console.log(missing_fields);
	
	    // fees
	    if (Object.keys(data.form.fees).length === 0) {
	      errors.push('Please register for at least one item.');
	    }
	
	    // accommodation
	    if (data.accommodation.required) {
	      var missing_accommodation_fields = [{ name: 'occupancy', label: 'Hotel Occupancy' }, { name: 'checkin_date', label: 'Check-in date' }, { name: 'checkout_date', label: 'Checkout date' }].filter(function (f) {
	        return !data.accommodation.hasOwnProperty(f.name);
	      }).map(function (f) {
	        return 'The ' + f.label + ' field is required.';
	      });
	      errors = errors.concat(missing_accommodation_fields);
	    }
	
	    // payment
	    if (data.form.total > 0 && !data.payment_details.payment_method) {
	      errors.push('Please select a payment method.');
	    }
	    if (data.form.total > 0 && data.payment_details.payment_method == 'credit_card') {
	      // CVC intentionally omitted
	      var missing_payment_fields = [{ name: 'name', label: 'Credit Card Name' }, { name: 'number', label: 'Credit Card Number' }, { name: 'exp_month', label: 'Credit Card Expiry Month' }, { name: 'exp_year', label: 'Credit Card Expiry Year' }].filter(function (f) {
	        return !data.payment_details.hasOwnProperty(f.name);
	      }).map(function (f) {
	        return 'The ' + f.label + ' field is required.';
	      });
	      errors = errors.concat(missing_payment_fields);
	    }
	
	    return errors.length == 0 ? false : errors;
	  },
	  onSubmit: function onSubmit(e) {
	    var _this = this;
	
	    e.preventDefault();
	    var val_data = { form: this.props.form, accommodation: this.props.accommodation, payment_details: this.props.payment_details };
	    var valErrors = this.validateForm(val_data);
	    if (valErrors) {
	      return (0, _sweetalert2.default)({
	        title: 'Error',
	        text: 'Please correct the following errors: <div class="well">' + valErrors.join('<br />') + '</ul></div>',
	        type: 'error',
	        html: true
	      });
	    }
	
	    var submit_data = {
	      record_id: this.props.form.record_id,
	      record_type: this.props.form.record_type,
	      category: this.props.form.category,
	      fees: this.props.fees.filter(function (f) {
	        return f.qty > 0;
	      }),
	      completed_form: this.props.fields.reduce(function (o, v, i) {
	
	        if (v.field_type == 'radio') {
	          //get checked value of radio
	          var checked_radio_value = '';
	          if ($("input[name='" + v.name + "']:checked").val()) {
	            checked_radio_value = $("input[name='" + v.name + "']:checked").val();
	          }
	
	          o[v.name] = checked_radio_value;
	        } else if (v.field_type == 'checkbox') {
	          //get checked value of radio
	          var checkbox_values = [];
	
	          checkbox_values = $("input[name='" + v.name + "']:checked").map(function () {
	            return $(this).val();
	          }).get();
	
	          o[v.name] = checkbox_values;
	        } else if (v.field_type != 'display') {
	          o[v.name] = v.value;
	        }
	        return o;
	      }, {}),
	      accommodation: this.props.accommodation,
	      subtotal: this.props.form.subtotal,
	      tax_name: this.props.form.tax_name,
	      tax_rate: this.props.form.tax_rate,
	      tax: this.props.form.tax,
	      total: this.props.form.total,
	      complimentary: this.props.form.complimentary,
	      payment_method: this.props.payment_details.payment_method
	
	      // console.dir(submit_data);
	      // console.dir(this.props.fields);
	
	      // attempt Stripe charge
	    };if (this.props.payment_details.payment_method == 'credit_card') {
	      (0, _sweetalert2.default)({
	        title: 'Please wait...',
	        text: 'Your credit card is being charged.',
	        type: 'info',
	        showCancelButton: false,
	        showConfirmButton: false,
	        closeOnConfirm: false
	      });
	
	      var charge = {
	        name: this.props.payment_details.name,
	        number: this.props.payment_details.number,
	        exp_month: this.props.payment_details.exp_month,
	        exp_year: this.props.payment_details.exp_year,
	        cvc: this.props.payment_details.cvc
	      };
	      Stripe.card.createToken(charge, function (status, response) {
	        if (response.error) {
	          return (0, _sweetalert2.default)({
	            title: 'Error',
	            text: response.error.message,
	            type: 'error'
	          });
	        } else {
	          submit_data.stripe_token = response.id;
	          _this.finalSubmit(submit_data);
	        }
	      });
	    } else {
	      // cheque
	      this.finalSubmit(submit_data);
	    }
	  },
	  finalSubmit: function finalSubmit(submit_data) {
	    var _this2 = this;
	
	    // FINAL SUBMIT
	    (0, _sweetalert2.default)({
	      title: 'Finalizing order...',
	      text: 'Now finalizing your order...',
	      type: 'info',
	      showCancelButton: false,
	      showConfirmButton: false,
	      closeOnConfirm: false
	    });
	
	    $.ajax({
	      url: window.location.href,
	      type: 'POST',
	      data: submit_data,
	      dataType: 'json'
	    }).done(function (data, textStatus, jqXHR) {
	      _sweetalert2.default.close();
	      _this2.props.actions.finalizeSubmission();
	    }).fail(function (jqXHR, textStatus) {
	      var response = $.parseJSON(jqXHR.responseText);
	      return (0, _sweetalert2.default)({
	        title: 'Error',
	        text: response.error,
	        type: 'error'
	      });
	    });
	  },
	  render: function render() {
	    var _props = this.props,
	        active = _props.active,
	        admin = _props.admin,
	        expired = _props.expired,
	        form = _props.form,
	        actions = _props.actions,
	        selected_category = _props.selected_category,
	        banner_image = _props.banner_image,
	        categories = _props.categories,
	        fees = _props.fees,
	        fields = _props.fields,
	        accommodation = _props.accommodation,
	        payment_details = _props.payment_details;
	
	
	    if (!active || expired) {
	      if (this.props.closed_message) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(_event_banner2.default, { src: banner_image }),
	          _react2.default.createElement(_event_thankyou2.default, { message: this.props.closed_message, continueUrl: 'http://www.cci.ca' })
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(_event_banner2.default, { src: banner_image }),
	          _react2.default.createElement(_event_thankyou2.default, { message: 'Online registration is now closed.', continueUrl: 'http://www.cci.ca' })
	        );
	      }
	    }
	
	    if (form.finalized) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(_event_banner2.default, { src: banner_image }),
	        _react2.default.createElement(_event_thankyou2.default, { message: selected_category.thank_you_message, continueUrl: selected_category.continue_url })
	      );
	    }
	
	    return _react2.default.createElement(
	      'form',
	      { action: window.location.href, method: 'POST', className: 'form-horizontal', onSubmit: this.onSubmit },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(_event_banner2.default, { src: banner_image }),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-offset-2 col-sm-8' },
	            _react2.default.createElement(_event_category_container2.default, { categories: categories, onChange: actions.updateForm })
	          )
	        ),
	        !form.category ? undefined : _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-offset-2 col-sm-8' },
	              _react2.default.createElement(_event_form_fields_container2.default, { onChange: actions.updateForm, onValidateEmail: actions.finalizeLogin, fields: fields, validatedMembership: form.validated_membership })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-offset-2 col-sm-8' },
	              _react2.default.createElement(_event_fee_container2.default, { is_front_end: true, admin: admin, fees: fees, onIncreaseFeeQty: actions.increaseFeeQty, onDecreaseFeeQty: actions.decreaseFeeQty })
	            )
	          ),
	          selected_category.accommodation_enabled ? _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-offset-2 col-sm-8' },
	              _react2.default.createElement(_event_form_accommodation_container2.default, { accommodation: accommodation, onChange: actions.updateAccommodationDetails })
	            )
	          ) : undefined,
	          form.total > 0 || form.complimentary ? _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-offset-2 col-sm-8' },
	              _react2.default.createElement(_event_form_payment_container2.default, _extends({ admin: admin, onComplimentaryChange: actions.changeComplimentary, onChange: actions.updatePaymentDetails, subtotal: form.subtotal, allow_cheque: form.allow_cheque, tax_name: form.tax_name, tax: form.tax, total: form.total, complimentary: form.complimentary }, payment_details))
	            )
	          ) : undefined,
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-offset-2 col-sm-8' },
	              _react2.default.createElement(
	                'div',
	                { className: 'panel' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'panel-body text-right' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: 'btn btn-primary btn-gradient btn-lg', type: 'submit' },
	                    'Submit'
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	function mapStateToProps(state, ownProps) {
	  // logic to merge state for the fees and fields into display props
	  var categories = ownProps.categories.filter(function (c) {
	    return !c.admin || c.admin && state.admin.isAdmin;
	  });
	  var selected_category = categories.find(function (c) {
	    return c.name == state.form.category;
	  });
	  var fees = !selected_category ? undefined : selected_category.fees.filter(function (f) {
	    return f.enabled && (!f.admin || f.admin && state.admin.isAdmin);
	  } // fee is enabled and if for admin's only, this is an admin
	  ).map(function (f) {
	    return state.form.fees && state.form.fees[f.name] ? Object.assign(f, state.form.fees[f.name]) : Object.assign(f, { qty: 0, price: f.price });
	  });
	  var fields = ownProps.fields.map(function (f) {
	    return Object.assign(f, { value: state.form[f.name] ? state.form[f.name] : '' });
	  });
	
	  return {
	    admin: state.admin,
	    form: state.form,
	    accommodation: state.accommodation,
	    payment_details: state.payment_details,
	    selected_category: selected_category,
	    categories: categories,
	    fees: fees,
	    fields: fields
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)(FormActions, dispatch)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EventRender);

/***/ }),

/***/ 263:
/*!***********************************!*\
  !*** ./src/event_render/index.js ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _reactDom = __webpack_require__(/*! react-dom */ 51);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _react = __webpack_require__(/*! react */ 2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(/*! jquery */ 11);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _redux = __webpack_require__(/*! redux */ 15);
	
	var _reactRedux = __webpack_require__(/*! react-redux */ 21);
	
	var _reducers = __webpack_require__(/*! ./reducers */ 267);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _event_render = __webpack_require__(/*! ./containers/event_render */ 262);
	
	var _event_render2 = _interopRequireDefault(_event_render);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var event_data = _jquery2.default.parseJSON($('#event-data').html());
	var admin_data = _jquery2.default.parseJSON($('#admin-data').html());
	
	var initialState = {
	  form: {
	    allow_cheque: event_data.allow_cheque,
	    complimentary: false,
	    tax_name: event_data.tax_name,
	    tax_rate: event_data.tax_rate,
	    tax: event_data.tax
	  },
	  admin: admin_data
	};
	
	var store = (0, _redux.createStore)(_reducers2.default, initialState);
	
	_reactDom2.default.render(_react2.default.createElement(
	  _reactRedux.Provider,
	  { store: store },
	  _react2.default.createElement(_event_render2.default, event_data)
	), document.getElementById('react-target'));

/***/ }),

/***/ 264:
/*!****************************************************!*\
  !*** ./src/event_render/reducers/accommodation.js ***!
  \****************************************************/
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = accommodation;
	var initialState = {
	  required: false
	};
	
	function accommodation() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'UPDATE_ACCOMMODATION_DETAILS':
	      var change = action.change;
	      // if we change to not required, discard all other details
	      if (change.required && change.required == 0) {
	        return action.change;
	      }
	      return Object.assign({}, state, action.change);
	
	    default:
	      return state;
	  }
	}

/***/ }),

/***/ 265:
/*!********************************************!*\
  !*** ./src/event_render/reducers/admin.js ***!
  \********************************************/
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = admin;
	var initialState = {
	  isAdmin: false
	};
	
	function admin() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    default:
	      return state;
	  }
	}

/***/ }),

/***/ 266:
/*!*******************************************!*\
  !*** ./src/event_render/reducers/form.js ***!
  \*******************************************/
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = form;
	var initialState = {
	  complimentary: false,
	  category: undefined,
	  fees: {},
	  subtotal: 0,
	  tax: 0,
	  total: 0,
	  finalized: false,
	  validated_membership: false,
	  record_id: undefined,
	  record_type: undefined
	};
	
	function calc(state) {
	  var totals = { subtotal: 0, tax: 0, total: 0 };
	  if (!state.complimentary) {
	    for (var f in state.fees) {
	      totals.subtotal += state.fees[f].price * state.fees[f].qty;
	    }
	    totals.tax = state.tax_rate ? state.tax_rate * totals.subtotal : 0;
	    totals.total = totals.subtotal + totals.tax;
	  }
	  return Object.assign({}, state, totals);
	}
	
	function form() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'UPDATE_FORM':
	      var change = action.change;
	      // if the category changes, reset the fees
	      if (change.category) {
	        change.fees = {};
	      }
	      return calc(Object.assign({}, state, change));
	
	    case 'INCREASE_FEE_QTY':
	      var fees = state.fees;
	      fees[action.fee_name] = fees[action.fee_name] || { qty: 0, price: action.price };
	      fees[action.fee_name].qty++;
	      return calc(Object.assign({}, state, { fees: fees }));
	
	    case 'DECREASE_FEE_QTY':
	      var fees = state.fees;
	      if (fees[action.fee_name].qty && fees[action.fee_name].qty > 0) {
	        fees[action.fee_name].qty--;
	        if (fees[action.fee_name].qty == 0) {
	          delete fees[action.fee_name];
	        }
	      }
	      return calc(Object.assign({}, state, { fees: fees }));
	
	    case 'CHANGE_COMPLIMENTARY':
	      return calc(Object.assign({}, state, { complimentary: action.complimentary }));
	
	    case 'FINALIZE_LOGIN':
	      // map logged in member to any matching form fields
	      var change = action.change;
	      change.record_id = change.id;
	      delete change.id;
	      change.validated_membership = true;
	      return Object.assign({}, state, change);
	
	    case 'FINALIZE_SUBMISSION':
	      return Object.assign({}, state, { finalized: true });
	
	    default:
	      return state;
	  }
	}

/***/ }),

/***/ 267:
/*!********************************************!*\
  !*** ./src/event_render/reducers/index.js ***!
  \********************************************/
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(/*! redux */ 15);
	
	var _form = __webpack_require__(/*! ./form */ 266);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _payment_details = __webpack_require__(/*! ./payment_details */ 268);
	
	var _payment_details2 = _interopRequireDefault(_payment_details);
	
	var _accommodation = __webpack_require__(/*! ./accommodation */ 264);
	
	var _accommodation2 = _interopRequireDefault(_accommodation);
	
	var _admin = __webpack_require__(/*! ./admin */ 265);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rootReducer = (0, _redux.combineReducers)({
	  form: _form2.default,
	  payment_details: _payment_details2.default,
	  accommodation: _accommodation2.default,
	  admin: _admin2.default
	});
	
	exports.default = rootReducer;

/***/ }),

/***/ 268:
/*!******************************************************!*\
  !*** ./src/event_render/reducers/payment_details.js ***!
  \******************************************************/
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = payment_details;
	var initialState = {};
	
	function payment_details() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'UPDATE_PAYMENT_DETAILS':
	      return Object.assign({}, action.change);
	
	    default:
	      return state;
	  }
	}

/***/ })

});


// WEBPACK FOOTER //
// EventRender.js